module.exports = __webpack_public_path__ + "static/warning-icon-0a632e223aabe48a8c13d1bcb3e30b11.svg";